'use strict';

const isMailToLink = obj => obj.href.match(/^mailto\:/);

const isLinkToPdf = obj => /.pdf$/.test(obj.href);

const isLinkToJs = obj => obj.href.match(/^javascript\:/);

const isLinkToEmptyUrl = obj => obj.href.match(/^$/);

const isLinkToExternalUrl = obj =>
  obj.href
    .replace(/http(s)?:\/\/(www\.)?/, '')
    .indexOf(location.hostname.replace('www.', '')) === -1;

const elementMatchesSelectorList = (obj, selectors) => {
  for (let i = 0; i < selectors.length; i += 1) {
    const selectorEls = document.querySelectorAll(selectors[i]);
    for (let k = 0; k < selectorEls.length; k += 1) {
      if (obj === selectorEls[k]) {
        return true;
      }
    }
  }
  return false;
};

const isWhiteListedLink = obj =>
  elementMatchesSelectorList(obj, ['.fine-print a']) && !obj.dataset.modalId;

const isBlackListedLink = obj =>
  elementMatchesSelectorList(obj, [
    '.diy-gift-card-msg a',
    ,
    '#options a',
    '.external-buy',
    '[data-bhw=CouponCTA]',
    '.gift-button',
  ]);

const isExternalLink = obj =>
  (isLinkToExternalUrl(obj) || isLinkToPdf(obj) || isWhiteListedLink(obj)) &&
  !(
    isMailToLink(obj) ||
    isLinkToJs(obj) ||
    isLinkToEmptyUrl(obj) ||
    isBlackListedLink(obj)
  );

const ExternalLinks = {
  init(payload, done) {
    const externalLinks = [...document.querySelectorAll('a')].filter(
      isExternalLink
    );
    externalLinks.forEach(linkEl => {
      linkEl.addEventListener('click', event => {
        event.preventDefault();
        window.open(linkEl.getAttribute('href'), '_blank');
      });
    });

    return done();
  },
};

window.ExternalLinks = ExternalLinks;
module.exports = ExternalLinks;
